import React, { memo, useCallback, ChangeEvent } from 'react';
import type { Node } from 'relatives-tree/lib/types';
import { URL_LABEL } from '../const';
import { personsValidate, NVal } from '~/utils/validate'
import {
  useSnackbar,
  SnackbarMessage as TSnackbarMessage,
  OptionsObject as IOptionsObject,
  // SharedProps as ISharedProps,
  // closeSnackbar,
} from 'notistack'
import { apiErrorHandler } from '~/utils/apiErrorHandler'

interface SourceSelectProps {
  value: string;
  items: Record<string, readonly Readonly<Node>[]>;
  onChange: (value: string, nodes: readonly Readonly<Node>[]) => void;
}

const localStorageDefaultUrlSourseName = 'react-family-2023.default-url'

export const SourceSelect = memo(
  function SourceSelect({ value, items, onChange }: SourceSelectProps) {
    const { enqueueSnackbar } = useSnackbar()
    const showNotif = useCallback((msg: TSnackbarMessage, opts?: IOptionsObject) => {
      if (!document.hidden) enqueueSnackbar(msg, opts)
    }, [enqueueSnackbar])
    const changeHandler = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
      const key = event.target.value;

      if (key === URL_LABEL) {
        const url = prompt('Paste the url to load:', localStorage.getItem(localStorageDefaultUrlSourseName) || undefined);
        if (!url) return;

        localStorage.setItem(localStorageDefaultUrlSourseName, url)

        fetch(url)
          .then((resp) => resp.json())
          .then(apiErrorHandler({
            validateFn: (arr) => {
              const result: NVal.TValidationResut = { ok: true }
              const validate = personsValidate(arr)
              if (!validate.ok) {
                result.ok = false
                result.reason = `Incorrect data: ${validate.reason || 'API ERR #1 (no reason)'}`
              }
              return result
            }
          }))
          .then((data) => Array.isArray(data) && onChange(key, data))
          .catch((err) => {
            showNotif(err.message || 'Unknown API ERR #0', { variant: 'error' })
          });
      }
      else onChange(key, items[key]);
    }, [items, onChange, showNotif]);

    return (
      <select value={value} onChange={changeHandler}>
        {Object.keys(items).map((item) => (
          <option key={item} value={item}>{item}</option>
        ))}
        <option value={URL_LABEL}>{URL_LABEL}</option>
      </select>
    );
  },
);
